import { Button, Divider, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { userLogout } from "../../../../../../actions/currentUser/actions";
import { NAVIGATION } from "../../../../../../locales/components/namespaces";
import {getRouteUrl} from "../../../../../../helpers/routing/getRouteUrl";
import {ROUTE_DASHBOARD} from "../../../../../../routers/routes";


const AccountPopupLoggedIn = ({ onClose }) => {
  const theme = useTheme();
  const { t } = useTranslation(NAVIGATION);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogout = () => {
    dispatch(userLogout());
    onClose();
    history.push(`/`)
  };

  const handleMyAccount = () => {
    onClose();
    history.push(getRouteUrl(ROUTE_DASHBOARD));
  };

  return (
    <Stack spacing={0}>
      {/* Actions */}
      <Stack
        spacing={0}
        sx={{
          px: "20px",
        }}
      >
        <Button
          fullWidth
          variant="containedPrimary"
          sx={{
            mt: "15px",
            borderRadius: "24px",
            borderColor: theme.palette.primary.main,
            height: "35px",
            fontSize: "12px",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
          onClick={handleMyAccount}
        >
          {t("account_popup_my_account")}
        </Button>

        <Divider sx={{ my: "12px" }} />

        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderRadius: "24px",
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            height: "35px",
            fontSize: "12px",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            mb: "15px",
          }}
          onClick={handleLogout}
        >
          {t("account_popup_logout")}
        </Button>
      </Stack>
    </Stack>
  );
};

export default AccountPopupLoggedIn;
